export const DEFAULT_PAGINATION_LIMIT = 20;

export function normalizePaginationLimit(limit) {
  const parsedLimit = Number(limit);

  return Number.isFinite(parsedLimit) && parsedLimit > 0
    ? parsedLimit
    : DEFAULT_PAGINATION_LIMIT;
}
